import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/header-title.module.css';

interface HeaderTitleProps extends TypographyProps {
    brand?: string | null;
}

function HeaderTitle({ tag = 'h1', brand = null, className, ...props }: HeaderTitleProps) {
    return (
        <Typography
            tag={tag}
            className={classNames([
                styles.container,
                {
                    [styles[brand]]: className !== null,
                    [className]: className !== null,
                },
            ])}
            {...props}
        />
    );
}

export default HeaderTitle;
